/* eslint-disable no-param-reassign */
/* global $ */

import filter from 'lodash/filter';
import find from 'lodash/find';
import map from 'lodash/map';
import Vue from 'vue';
import Vuex from 'vuex';
import Anderson from './assets/anderson-medical.jpg';
import BlowingRock from './assets/blowing-rock-pluc.jpg';
import FallsPediatric from './assets/falls-pediatrics-uc-granite-falls.jpg';
import Rivercrest from './assets/rivercrest.jpg';
import Robbins from './assets/robbins-medical.jpg';
import Southfork from './assets/southfork.jpg';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    announcements: [],
    locations: [],
  },

  getters: {
    isDevEnvironment() {
      return window.location.hash.indexOf('sup') !== -1;
    },

    filteredLocations(state, getters) {
      return filter(state.locations, (location) => {
        // Special note: We don't need to check the go-live date here.
        // Our API endpoint checks it and forces location.dev_only = false if needed.

        if (!getters.isDevEnvironment) {
          return !location.dev_only;
        }

        return true;
      });
    },

    locationData: (state) => (locationId) => find(
      state.locations,
      (location) => parseInt(location.location_id, 10) === parseInt(locationId, 10),
    ),
  },

  mutations: {
    setAnnouncements(state, announcements) {
      state.announcements = announcements;
    },
    setLocations(state, locations) {
      state.locations = locations;
    },
  },

  actions: {
    loadData({ commit, getters }) {
      let url = 'https://api.caldwellwaittimes.com/data';
      if (getters.isDevEnvironment) {
        url += '?dev';
      }

      $.ajax({
        dataType: 'json',
        method: 'GET',
        url,
      })
        .then((data) => {
          const locations = map(data.locations, (location) => {
            if (location.name.indexOf('Anderson') > -1) {
              location.photo = Anderson;
            } else if (location.name.indexOf('Robbins') > -1) {
              location.photo = Robbins;
            } else if (location.name.indexOf('Falls Pediatric') > -1) {
              location.photo = FallsPediatric;
            } else if (location.name.indexOf('Blowing Rock') > -1) {
              location.photo = BlowingRock;
            } else if (location.name.indexOf('RiverCrest') > -1) {
              location.photo = Rivercrest;
            } else if (location.name.indexOf('Southfork') > -1) {
              location.photo = Southfork;
            }

            return location;
          });

          commit('setAnnouncements', data.announcements);
          commit('setLocations', locations);
        });
    },
  },
});

export default store;
